import Container from '@/components/base/Container';
import Section from '@/components/base/Section';
import SectionHeading from '@/components/base/SectionHeading';
import PageIntro from '@/components/base/PageIntro';
import NumberedSteps from '@/components/base/NumberedSteps';
import PracticeFeature from './components/PracticeFeature';
import AboutClosing from './components/AboutClosing';

const values = [
  { icon: 'ri-chat-check-line', title: 'Responsive communication', text: 'Questions get acknowledged promptly and answered clearly, and people are told what happens next.' },
  { icon: 'ri-tools-line', title: 'Proactive upkeep', text: 'We plan maintenance ahead of time rather than waiting for things to fail.' },
  { icon: 'ri-file-shield-2-line', title: 'Accountability', text: 'Work is documented, decisions are recorded and we report on what we said we would do.' },
  { icon: 'ri-home-heart-line', title: 'Respect for residents', text: 'Every community is someone\u2019s home. We act with courtesy, discretion and patience.' },
];

const workSteps = [
  { title: 'With boards and owners', text: 'We meet on an agreed schedule, prepare clear reports and bring recommendations with options, so decisions stay with the people responsible for them.' },
  { title: 'With residents', text: 'Residents have one clear way to reach us, receive notices ahead of planned work and get updates on the requests they submit.' },
  { title: 'With vendors', text: 'We define scopes, compare bids when needed, schedule work around residents and check that it was completed as agreed.' },
];

export default function About() {
  return (
    <>
      <PageIntro
        eyebrow="About"
        title="We take care of the places people share."
        lead="Our purpose is simple: help residential communities run smoothly, so boards can govern with confidence and residents can enjoy where they live."
      />

      <PracticeFeature />

      <Section labelledBy="values-heading">
        <Container>
          <SectionHeading id="values-heading" eyebrow="Values" title="What guides our work." />
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <article key={v.title} className="flex h-full flex-col rounded-[12px] border border-background-200 bg-background-50 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-50 text-[20px] text-accent-500">
                  <i className={v.icon} aria-hidden="true"></i>
                </span>
                <h3 className="mt-6 font-heading text-[20px] font-semibold leading-[1.2] text-foreground-950 md:text-[22px]">{v.title}</h3>
                <p className="mt-3 text-[16px] leading-[1.6] text-foreground-700">{v.text}</p>
              </article>
            ))}
          </div>
        </Container>
      </Section>

      <Section labelledBy="work-heading">
        <Container>
          <SectionHeading
            id="work-heading"
            eyebrow="How we work"
            title="Clear roles with everyone involved in the community."
          />
          <NumberedSteps steps={workSteps} />
        </Container>
      </Section>

      <AboutClosing />
    </>
  );
}